"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import { tryApiFetchNoJson } from "./utils/utils";
var defaults_1 = __importDefault(require("./defaults"));
var errors_1 = require("./utils/errors");
var dexie_1 = __importDefault(require("dexie"));
/**
 * Authorization class for sounditi WebProjects
 *
 * It manages directly the localStorage to save {@link TokenPair}
 *
 * @param {Object} options
 * @param {string} [options.hosts=defaults] host for the api, defaults to: {@link defaultconfig}
 * @param {string} [options.scope=defaults.scope] scope for the api, defaults to: {@link defaultconfig}
 *
 * @example
 * const options = {
 *  host: 'http://another.host',
 *  scope: 'user'
 * };
 *
 * const auth = new SounditiApi(options);
 *
 * const {auth: tokenPair, payload} = await auth.login(email, password);
 *
 * const {accessToken, renewalToken} = tokenPair;
 *
 * @category AUTH
 */
var SounditiAuth = /** @class */ (function () {
    function SounditiAuth(config) {
        var _this = this;
        /**
         * Checks that the scope provided is correct
         * @private
         */
        this.init = function () {
            var validScopes = ['user', 'admin', 'superadmin'];
            if (!validScopes.includes(_this.scope))
                throw new Error('The scope provided is not valid. Choose from: user, admin, superadmin');
        };
        /**
         * Returns the tokenKey name
         * @private
         */
        this.getTokenKey = function () {
            return _this.tokenKey;
        };
        /**
         * Returns the renewalTokenKey name
         * @private
         */
        this.getRenewalTokenKey = function () {
            return _this.renewalTokenKey;
        };
        /**
         * Removes the tokenPair from local storage
         */
        this.removeToken = function () {
            window.localStorage.removeItem(_this.tokenKey);
            window.localStorage.removeItem(_this.renewalTokenKey);
            window.localStorage.removeItem(_this.expirationKey);
        };
        /**
         * saves the token session in localstorage
         */
        this.setToken = function (tokenPair, expirationT) {
            window.localStorage.setItem(_this.tokenKey, tokenPair.accessToken);
            window.localStorage.setItem(_this.renewalTokenKey, tokenPair.renewalToken);
            window.localStorage.setItem(_this.expirationKey, expirationT);
        };
        /**
         * retrieves the token from localStorage
         */
        this.getToken = function () {
            return window.localStorage.getItem(_this.tokenKey) || '';
        };
        /**
         * retrieves the renewalToken from localStorage
         */
        this.getRenewalToken = function () {
            return window.localStorage.getItem(_this.renewalTokenKey);
        };
        this.checkTokenExpiration = function () {
            var tokenExpiration = window.localStorage.getItem(_this.expirationKey);
            if (!tokenExpiration)
                return true;
            return new Date().getTime() > 1000 * parseInt(tokenExpiration);
        };
        this.logOut = function () {
            dexie_1.default.delete('ft2-control');
        };
        var _a = __assign(__assign({}, defaults_1.default), config), auth_host = _a.auth_host, scope = _a.scope;
        this.host = auth_host;
        this.scope = scope;
        this.tokenKey = "snd-token-" + scope;
        this.renewalTokenKey = "snd-renewalToken-" + scope;
        this.expirationKey = "snd-expiration-" + scope;
        this.init();
    }
    /**
     * Check if a token was issued by Sounditi
     *
     * @param token a jwt token
     *
     * @returns the token payload or false otherwise
     */
    SounditiAuth.prototype.checkToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json, responseObject, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, fetch(this.host + "/check?token=" + token, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 5];
                        if (!json.decoded) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.setToken(json.auth || {}, json.decoded.exp || '')];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 5: throw new Error(json.message);
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_1 = _a.sent();
                        throw new Error(error_1);
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Check and returns a new tokenPair from a renewalToken
     * @param token
     *
     * @returns {LoginResponse}
     */
    SounditiAuth.prototype.renewToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json, responseObject, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, fetch(this.host + "/renew", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ token: token })
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 5];
                        if (!json.decoded) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.setToken(json.auth || {}, json.decoded.exp || '')];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 5: throw new Error(json.message);
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_2 = _a.sent();
                        throw new Error(error_2);
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Signs up a user in FT2
     *
     * @param {string} name User provided name
     * @param {string} email user email
     * @param {string} password user plainText pasword
     * @param {string} [lead = 'organic'] lead to track origin of users
     *
     * @todo enforce password validation
     */
    SounditiAuth.prototype.signUp = function (name, email, password, lead) {
        if (lead === void 0) { lead = 'organic'; }
        return __awaiter(this, void 0, void 0, function () {
            var response, json, responseObject, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(this.host + "/signup", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({ name: name, email: email, password: password, lead: lead }),
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        json = _a.sent();
                        if (response.status === 400) {
                            throw new Error(json);
                        }
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 3:
                        error_3 = _a.sent();
                        throw new Error(error_3.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Send an email to the logged user with a new password
     */
    SounditiAuth.prototype.resendValidation = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json, responseObject, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(this.host + "/resendvalidation?email=" + email)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        json = _a.sent();
                        if (response.status === 400) {
                            throw new Error(json);
                        }
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 3:
                        error_4 = _a.sent();
                        throw new Error(error_4.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initializes a password remember mail sequence
     */
    SounditiAuth.prototype.requestPassword = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json, responseObject, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(this.host + "/requestpassword?email=" + email)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        json = _a.sent();
                        if (response.status === 400) {
                            throw new Error(json);
                        }
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 3:
                        error_5 = _a.sent();
                        throw new Error(error_5.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Logs an user in FT2 returning a
     *
     *
     * @param email
     * @param password
     *
     * @returns {Promise<LoginResponse>}
     *
     * @throws {LoginError}
     *
     */
    SounditiAuth.prototype.login = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json, responseObject, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, fetch(this.host + "/login", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ email: email, password: password }),
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 5];
                        if (!json.decoded) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.setToken(json.auth || {}, json.decoded.exp || '')];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 5: throw new errors_1.LoginError(json.message);
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_6 = _a.sent();
                        throw error_6;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * sets a new password for a user
     *
     * @param oldPassword
     * @param newPassword
     *
     * @returns LoginResponse
     *
     * @todo invalidate old tokens
     */
    SounditiAuth.prototype.updatePassword = function (oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var token, response, json, responseObject, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, fetch(this.host + "/user/updatepassword", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': "Bearer " + token
                                },
                                body: JSON.stringify({ oldPassword: oldPassword, newPassword: newPassword }),
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 6];
                        if (!json.decoded) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.setToken(json.auth || {}, json.decoded.exp || '')];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 6: throw new Error(json.message);
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_7 = _a.sent();
                        throw new Error(error_7);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Updates the email, resets the password and sends an email with the new password
     *
     * @param {string} userId user uuid
     * @param {string} newEmail the new email
     *
     * @returns UserItem
     *
     */
    SounditiAuth.prototype.updateUserEmailAndResetPassword = function (userId, newEmail, linkUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var token, response, json, responseObject, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, fetch(this.host + "/user/updateUserEmail", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': "Bearer " + token
                                },
                                body: JSON.stringify({ userId: userId, newEmail: newEmail, linkUrl: linkUrl }),
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 6];
                        if (!json.decoded) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.setToken(json.auth || {}, json.decoded.exp || '')];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 6: throw new Error(json.message);
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_8 = _a.sent();
                        throw new Error(error_8);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Call this function from the wizard when an user wants to create a link of a test with an existing email.
     * This function logs the user in and asigns the created campaign to this user
     *
     * @param {WizardLoginRequest} wizardLoginRequest user uuid
     *
     * @returns {Promise<WizardLoginResponse>} Login response with the updated campaign
     *
     */
    SounditiAuth.prototype.wizardLogin = function (wizardLoginRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var token, response, json, responseObject, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, fetch(this.host + "/wizardLogin", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': "Bearer " + token
                                },
                                body: JSON.stringify(wizardLoginRequest),
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 6];
                        if (!json.decoded) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.setToken(json.auth || {}, json.decoded.exp || '')];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 6: throw new Error(json.message);
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_9 = _a.sent();
                        throw new Error(error_9);
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Deletes an user
     *
     * @param {string} userId user uuid
     * @param {string} email user email
     *
     */
    SounditiAuth.prototype.deleteUser = function (userId, email) {
        return __awaiter(this, void 0, void 0, function () {
            var token, response, json, responseObject, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, fetch(this.host + "/deleteUser", {
                                method: 'DELETE',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': "Bearer " + token
                                },
                                body: JSON.stringify({ id: userId, email: email }),
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        if (response.status === 400) {
                            throw new Error(json);
                        }
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 4:
                        error_10 = _a.sent();
                        throw new Error(error_10.message);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Logs an user in FT2 returning a
     *
     *
     * @param email
     * @param password
     *
     * @returns {Promise<LoginResponse>}
     *
     * @throws {LoginError}
     *
     */
    SounditiAuth.prototype.controlPanelLogin = function (email, password, host, code) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json, responseObject, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, fetch(host + "/login", {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ email: email, password: password, code: code }),
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 5];
                        if (!json.decoded) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.setToken(json.auth || {}, json.decoded.exp || '')];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        responseObject = json;
                        return [2 /*return*/, responseObject];
                    case 5: throw new errors_1.LoginError(json.message);
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_11 = _a.sent();
                        throw error_11;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ;
    return SounditiAuth;
}());
exports.default = SounditiAuth;
//# sourceMappingURL=Auth.js.map